import { FunctionComponent, KeyboardEvent } from 'react'
import { Image } from 'src/componentsV2/CoreUX/primitives/Image/Image'
import { Text } from 'src/componentsV2/CoreUX/primitives/Text/Text'
import { Label } from 'src/componentsV2/CoreUX/primitives/Label/Label'
import { useActions } from 'src/hooks/useActions'
import './CollectionCard.scss'
import { CollectionCardProps } from './CollectionCard.types'

export const CollectionCard: FunctionComponent<CollectionCardProps> = ({
  title,
  subtitle,
  rating,
  image,
  tag,
  actions
}) => {
  const { onClick } = useActions(actions)

  const handleKeyDown = (event: KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      onClick?.()
    }
  }

  return (
    <div className="core-ux-collection-card" data-testid="collection-card">
      <button
        className="core-ux-collection-card-image-container"
        onClick={onClick}
        onKeyDown={handleKeyDown}
        type="button">
        <Image {...image} />
        <div className="core-ux-collection-card-image-gradient"></div>
        {tag && (
          <div className="core-ux-collection-card-tag">
            <Label {...tag} />
          </div>
        )}
      </button>
      <div className="core-ux-collection-card-text-container">
        <div className="core-ux-collection-card-title-container">
          <Text {...title} />
          {rating && (
            <div className="core-ux-collection-card-rating">
              <Label {...rating} />
            </div>
          )}
        </div>
        {subtitle && (
          <Text
            {...subtitle}
            className="core-ux-collection-card-text-container-subtitle"
          />
        )}
      </div>
    </div>
  )
}
